import { render } from "./holidays.vue?vue&type=template&id=c6b507a2"
import script from "./holidays.vue?vue&type=script&lang=js"
export * from "./holidays.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__